import { useQuery, keepPreviousData, useMutation } from '@tanstack/react-query';
import { getClients, createClient, getClientsFromSoftseguros, updateClient, getClient, createOrUpdateClient } from '@features/clients/services/clientsService';

const BASE = 'clients';

export const clientsQueryKeys = {
    base: () => [BASE],
    detail: (id) => [BASE, 'detail', id],
    list: (data) => data ? [BASE, 'list', data] : [BASE, 'list'],
    listFromSoftseguros: (data) => data ? [BASE, 'listFromSoftseguros', data] : [BASE, 'listFromSoftseguros'],
}

export const useGetClients = (data) => {
    return useQuery({
        queryKey: clientsQueryKeys.list(data),
        placeholderData: keepPreviousData,
        queryFn: () => getClients(data),
    });
};

export const useGetClient = (id) => {
    return useQuery({
        queryKey: clientsQueryKeys.detail(id),
        queryFn: () => getClient(id),
        enabled: !!id,
    });
};

export const useGetClientsFromSoftseguros = (data) => {
    return useQuery({
        queryKey: clientsQueryKeys.listFromSoftseguros(data),
        placeholderData: keepPreviousData,
        queryFn: () => getClientsFromSoftseguros(data),
    })
}

export const useCreateClient = () => {
    return useMutation({
        mutationFn: (data) => createClient(data),
    });
};

export const useUpdateClient = () => {
    return useMutation({
        mutationFn: ({ id, data }) => updateClient(id, data),
    });
};

export const useCreateOrUpdateClient = () => {
    return useMutation({
        mutationFn: (data) => createOrUpdateClient(data),
    });
};